module.exports = __webpack_public_path__ + "img/daichuli.11044da9.png";